import { render, staticRenderFns } from "./RastreabilidadeExame.vue?vue&type=template&id=9798f4b4&"
import script from "./RastreabilidadeExame.vue?vue&type=script&lang=js&"
export * from "./RastreabilidadeExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports